import { css } from 'lit';

export const styles = css `
  :host {
    display: block;
    padding-block: var(--u-list-padding, 8px);
  }
`;
